// src/App.jsx
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import Clients from './pages/Clients';
import Navigation from './components/Navigation';
import PrivateRoute from './components/PrivateRoute';
import { useAuth } from './context/AuthContext';
import './App.css';

function AppContent() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  // 只在登入頁面隱藏導航列
  const showNavigation = isAuthenticated && location.pathname !== '/login';

  return (
    <>
      <div className={showNavigation ? 'main-content' : ''}>
        <Routes>
          <Route 
            path="/login" 
            element={isAuthenticated ? <Navigate to="/dashboard" /> : <Login />} 
          />
          <Route element={<PrivateRoute />}>
            <Route element={<AuthenticatedLayout />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/enterprise/:enterpriseId" element={<Dashboard />} />
              <Route path="/enterprise/:enterpriseId/profile" element={<Profile />} />
              <Route path="/enterprise/:enterpriseId/clients" element={<Clients />} />
              <Route path="/enterprise/:enterpriseId/clients/:clientId/edit" element={<Clients />} />
              <Route path="/enterprise/:enterpriseId/settings" element={<Settings />} />
            </Route>
            {/* 其他需要登入的頁面 */}
          </Route>
          <Route path="/" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} />} />
        </Routes>
      </div>
    </>
  );
}

function AuthenticatedLayout() {
  return <><Navigation /><Outlet /></>;
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
